import HorizontalCarousel from '@component/carousel/src/views/HorizontalCarousel';
import { ScrollType } from '@component/carousel/src/views/Carousel';
import ResponsiveThumbnailSizeDecider from '../util/ResponsiveThumbnailSizeDecider';

export default class CustomHorizontalCarousel extends HorizontalCarousel {
  /**
   *  doSizing is resize height of the carousel
   */
  doSizing() {
    if (this.childrenView.length === 0) {
      return;
    }

    this.doChildSizing();

    const { childWidth } = this.childSize;

    this.buttonsContainers = this.carouselView.querySelectorAll('.carousel-chevron');

    // get integer value of carousel Wrapper height
    let carouselWrapperWidth = this.el.offsetWidth - ((this.opts.swatch) ?
      (2 * (this.buttonsContainers[0].offsetWidth)) : this.buttons[0].offsetWidth);
    if (this.opts.overlayButtons) {
      carouselWrapperWidth = this.el.offsetWidth;
    }

    // set carousel wrapper width again
    this.carouselWrapper.style.width = `${carouselWrapperWidth}px`;

    // calculate minimum number of child view that can fit in one page (with margin)
    let childPerPage = Math.floor((carouselWrapperWidth) / childWidth);

    // see if there is empty space in the page at the end with minimum number of child view
    const extraChild = Math.floor(carouselWrapperWidth - (childWidth * childPerPage));

    // get Readonly computed style of each child
    const { marginRight, paddingRight } = getComputedStyle(this.childrenView[0]);

    // see if one more child can fit at the end if we do not count margin bottom of last child
    childPerPage += Math.floor(extraChild /
      (childWidth - parseInt(marginRight, 10) - parseInt(paddingRight, 10)));
    childPerPage = childPerPage || 1;

    const maxPage = Math.floor(this.childrenView.length / childPerPage) + ((this.childrenView.length % childPerPage) > 0 ? 1 : 0);
    // Resize carousel Wrapper height and scroller's width
    this.scroller.style.width = `${childPerPage * (maxPage + 1) * childWidth}px`;
    // if page is true then calculate maximum number of child view can fit in the each page and number of pages
    if (this.opts.scrollType === ScrollType.PAGE) {
      this.page.max = maxPage;

      // Need to update current: if resize happens and if childPerPage is different now
      if ((this.page.current > 1) && (this.page.childPerPage !== childPerPage)) {
        this.page.current = Math.floor(this.page.lastItemShown / childPerPage) + ((this.page.lastItemShown % childPerPage) > 0 ? 1 : 0);
      }

      // set new maximum page and child per page
      this.page.childPerPage = childPerPage;

      this.lastItemShown();
    } else {
      // else next/prev button move one element by one element
      this.page.max = this.childrenView.length - 1;
    }

    this.page.childPerPage = childPerPage;
  }

  doChildSizing() {
    const ResponsiveDecider = ResponsiveThumbnailSizeDecider.constructor();
    const hasBreakpointScreenSize = ResponsiveDecider.hasBreakpointScreenSizeChange(this.opts.page, this.opts.zone);
    if (hasBreakpointScreenSize) {
      const childWidth = ResponsiveDecider.breakpointScreenItemWidth(this.opts.page, this.opts.zone);
      this.childSize.childWidth = childWidth;
      this.childrenView.forEach((elem) => { elem.style.width = `${childWidth}px`; }); // eslint-disable-line no-param-reassign
    }
  }
}
